'use client';

import {
  Box,
  Container,
  Text,
  Title,
  Flex,
  rem,
  type ContainerProps,
  type BoxProps,
} from '@mantine/core';
import type { ReactNode, SVGProps } from 'react';

export interface ResultBlockProps extends Omit<ContainerProps, 'title'> {
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  iconSize?: number;
  iconProps?: BoxProps;
  title?: string | ReactNode;
  description?: string | ReactNode;
  requestId?: string;
  children?: ReactNode;
}

export function ResultBlock({
  icon: Icon,
  iconSize = 120,
  iconProps,
  title,
  description,
  requestId,
  children,
  className,
  ...props
}: ResultBlockProps) {
  return (
    <Container {...props}>
      <Flex
        direction="column"
        mx="auto"
        maw={400}
        justify="center"
        align="center"
        gap={rem(8)}
        py={rem(48)}
        ta="center"
      >
        <Box
          pos="relative"
          mx="auto"
          mb={8}
          h={iconSize}
          w="100%"
          {...iconProps}
        >
          <Icon height="100%" width="100%" />
        </Box>
        {/* {iconUrl ? (
          <Box pos="relative" mx="auto" mb={8} h={120} w="100%">
            <Image
              alt="404"
              fill
              style={{ objectFit: 'contain' }}
              src={iconUrl}
              priority
            />
          </Box>
        ) : null} */}
        <Title order={2} size="h5" fw={600} ta="center">
          {title}
        </Title>
        {description ? (
          <Text size="sm" ta="center" c="neutral" fw={500}>
            {description}
          </Text>
        ) : null}
        {requestId ? (
          <Text size="sm" ta="center" c="neutral" fw={600}>
            Request ID:{' '}
            <code className="font-mono font-normal">{requestId}</code>
          </Text>
        ) : null}
        {children}
      </Flex>
    </Container>
  );
}
